import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { decorateWith, withName } from 'helpers/decorator';
import { isEmpty } from 'helpers/verify';
import { selectCmsPath } from 'redux/saga/selectors/cms';

export const mapStateToProps = state => ({
  path: selectCmsPath(state),
});

export const mapDispatchToProps = {
  // We need to map dispatch for compatibility reasons
  // in the short term. It will be removed in the near future
  // as we make modules connected.
  dispatch: obj => obj,
};

export class CmsModulesUnwrapped extends React.Component {
  render() {
    const { dispatch, modules, path } = this.props;

    if (isEmpty(modules)) {
      return null;
    }

    return modules.map(({ Component, cmsModuleId, props }, index) => (
      // eslint-disable-next-line react/no-array-index-key
      <div data-cms-module-id={cmsModuleId} key={`${Component.displayName}_${index}`}>
        <Component
          cmsModuleId={cmsModuleId}
          path={path}
          {...props}
          {...(Component.handlerMapper ? Component.handlerMapper(dispatch) : {})}
        />
      </div>
    ));
  }
}

export const CmsModuleShape = PropTypes.shape({
  cmsModuleId: PropTypes.string.isRequired,
  Component: PropTypes.func.isRequired,
  props: PropTypes.object.isRequired,
});

CmsModulesUnwrapped.propTypes = {
  dispatch: PropTypes.func,
  modules: PropTypes.arrayOf(CmsModuleShape),
  path: PropTypes.string,
};

export const CmsModules = decorateWith(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('CmsModules')
)(CmsModulesUnwrapped);
